import React from 'react'
import ReactDOM from 'react-dom'

const Loading = () => {
    return <div className="happy-cart__please-wait">
        Идёт загрузка.. Пожалуйста подождите..
    </div>
}

export default Loading